import { getLabels } from "../api";

export const fetchMissingLabels = (i18n: any) => async (keys: string[]) => {
  const lang = i18n.language;
  const ns = i18n.options.defaultNS;
  try {
    const labels = await getLabels(ns, lang, keys);
    i18n.addResources(lang, ns, labels);
    i18n.changeLanguage(lang);
  } catch (error) {}
};
